import React, { Component } from "react"

export default class CalToolBar extends Component {
  constructor(props) {
    super(props)
  }

  navigate = (action) => {
    this.props.onNavigate(action)
  }

  render() {
    let navigateConst = {
      PREVIOUS: "PREV",
      NEXT: "NEXT",
      TODAY: "TODAY",
      DATE: "DATE",
    }

    let {
      localizer: { messages },
      label,
    } = this.props

    return (
      <div className="rbc-toolbar" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <span className="rbc-toolbar-label" style={{ fontFamily: "Poppins, sans-serif", fontSize: "14px" }}>
          {label}
        </span>
        <span className="rbc-btn-group">
          <button
            type="button"
            onClick={() => this.navigate(navigateConst.PREVIOUS)}
            style={{ 
                fontFamily: "Poppins, sans-serif",
                fontSize: "12px"
            }}
          >
            &lt;
          </button>
          <button
            type="button"
            onClick={() => this.navigate(navigateConst.NEXT)}
            style={{ 
                fontFamily: "Poppins, sans-serif",
                fontSize: "12px"
            }}
          >
            &gt;
          </button>
        </span>
      </div>
    )
  }
}
